import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { isTimeBeforeTimeNow } from 'services/utils/dateCalculations';
import useShopFormat from 'hooks/useShopFormat';

interface OwnProps {
	deliveryDate: string;
	informationText: string;
	spacing: 'normal' | 'dense' | 'none';
}

type Props = OwnProps;

export const RentalCardDeliveryTime = (props: Props) => {
	const { deliveryDate, informationText } = props;
	const classes = useStyles(props);
	const dateExpired = deliveryDate ? isTimeBeforeTimeNow(deliveryDate) : true;
	const { localFormat } = useShopFormat();

	const formattedDeliveryDate = deliveryDate ? localFormat(deliveryDate, 'ddd D.M., HH:mm') : null;
	return (
		<div className={classes.root}>
			<Typography variant="body2" color="textSecondary" align="right">
				{informationText}
			</Typography>
			<Typography variant="body2" color={dateExpired ? 'error' : 'initial'} align="right">
				{formattedDeliveryDate}
			</Typography>
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
	root: ({ spacing }: Props) => ({
		marginTop: (() => {
			switch (spacing) {
				case 'none':
					return 0;
				case 'dense':
					return theme.spacing(0.5);
				case 'normal':
					return theme.spacing(1);
			}
		})(),
		marginBottom: (() => {
			switch (spacing) {
				case 'none':
					return 0;
				case 'dense':
					return theme.spacing(0.5);
				case 'normal':
					return theme.spacing(1);
			}
		})(),
	}),
}));

export default RentalCardDeliveryTime;
